<template>
  <div class="block-wrap block-specification" style="padding: 10px">
    <div v-for="(s, sindex) in specifications" :key="sindex">
      <el-form class="title-bg" ref="skuForm" :model="s" :rules="skuRules" inline>
        <div>规格名：</div>
        <el-form-item label="" prop="name">
          <el-input style="width: 140px" v-model="s.name" @keyup.enter.native="e => nameEnter(sindex)" :maxlength="20"></el-input>
        </el-form-item>
        <el-button class="delete-btn" type="link" @click="removeSpName(sindex)">删除</el-button>
      </el-form>
      <div class="specification-value">
        <div>规格值：</div>
        <vue-draggable
          class="specification-value-flex"
          v-model="specifications[sindex].values"
          filter=".drag-ignore_item"
          handle=".drag-icon-wrap"
          :group="{ name: s.name, pull: 'clone', put: false }"
          :animation="500"
        >
          <div
            v-for="(v, vi) in specifications[sindex].values"
            :key="v.valueKey"
            class="specification-value-flex_item"
            style="margin-bottom: 16px"
          >
            <el-form ref="specFormRef" :key="vi" :model="v">
              <el-form-item prop="value" :rules="genFormItemValueRule(s, v, vi)">
                <div class="del-input-wrap">
                  <el-input
                    :ref="`${sindex}-${vi}`"
                    placeholder="请输入"
                    class="specification-value-flex_input"
                    @keyup.enter.native="e => valueEnter(sindex, vi)"
                    @input="e => valueInput(v)"
                    v-model="v.value"
                  ></el-input>
                  <div @click="removeSpValue(sindex, vi, v)" class="del-btn"><i class="el-icon-close" /></div>
                  <drag-item-content></drag-item-content>
                </div>
              </el-form-item>
              <el-form-item class="remarkWrap" prop="remark" :rules="genFormItemRemarkRule(v)">
                <el-input
                  class="input-remark"
                  :ref="`${sindex}-${vi}-remark`"
                  placeholder="备注"
                  @input="remarkInput"
                  v-model="v.remark"
                ></el-input>
              </el-form-item>
              <el-form-item v-if="sindex === 0" prop="imageUrl" :rules="genFormItemImgRule(v, s, `${sindex}-${vi}-img`)">
                <div class="specification-value-flex_img">
                  <ImgUpload
                    :ref="`${sindex}-${vi}-img`"
                    :width="80"
                    :height="80"
                    :size="150"
                    :file="v.imageUrl === '/resources/css/build/images/no_pic.png' ? '' : v.imageUrl"
                    @upload-success="url => imageUploadSuccess(url, v, sindex, vi)"
                    @del="() => imageUploadDel(v, sindex, vi)"
                    v-bind="imgLimits"
                    :isSingle="true"
                    :autoCropImageParams="{targetWidth:800,targetHeight:800}"
                  />
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="specification-value-flex_item drag-ignore_item">
            <el-button @click="addSpValue(sindex)" type="link">添加规格值</el-button>
          </div>
        </vue-draggable>
      </div>
      <div class="tips ft-12 ml-70" v-if="sindex === 0" style="color: #ccc">
        <span>{{ tipText }}</span>
      </div>
    </div>
    <div class="title-bg">
      <el-button @click="addSpName">添加商品规格</el-button>
    </div>
  </div>
</template>

<script>
import ImgUpload from '@/components/Uploads/ImgUpload';
import { dragItemMixin } from '../../../utils/mixins';

export default {
  components: {
    ImgUpload,
  },
  mixins: [dragItemMixin],
  model: {
    prop: 'values',
    event: 'change',
  },
  props: {
    values: {
      type: Array,
      default() {
        return [];
      },
    },
    imgLimits: {
      type: Object,
      default: () => {
        return {};
      },
    },
    tipText: {
      type: String,
      default: '默认取商品第一张主图，买家选择不同规格会看到对应规格图片，建议尺寸：800 x 800像素，建议格式：png，jpg，jpeg格式',
    },
  },
  data() {
    return {
      specifications: [],
      specOptions: [], // 规格名下拉框列表项
      selectLoading: false, // 规格名下拉框loading
    };
  },
  computed: {
    skuRules() {
      return {
        name: [
          {
            validator: (_, value, callback) => {
              if (!value) {
                return callback(new Error('规格名必填'));
              }
              return callback();
            },
            trigger: 'change',
          },
        ],
      };
    },
  },
  watch: {
    values: {
      handler(v) {
        this.specifications = v;
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    // 属性备注输入事件
    remarkInput() {
      window.__spcificationRemark_changed = true; // 用于skuList生成时的图片取值规则
    },
    // 规格名回车事件
    nameEnter(sindex) {
      let firstInputVm = this.$refs[`${sindex}-0`]; // 当前规格下的第一个规格值输入框
      firstInputVm = firstInputVm ? firstInputVm[0] : firstInputVm;
      if (!firstInputVm) {
        // 为空需要创建一个
        this.addSpValue(sindex);
        this.$nextTick(() => {
          this.$refs[`${sindex}-0`][0].focus();
        });
      } else {
        // 聚焦到第一个
        firstInputVm.focus();
      }
    },
    // 规格值回车事件
    valueEnter(sindex, vindex) {
      let nextInputVm = this.$refs[`${sindex}-${vindex + 1}`];
      nextInputVm = nextInputVm ? nextInputVm[0] : nextInputVm;
      if (!nextInputVm) {
        this.addSpValue(sindex);
        this.$nextTick(() => {
          this.$refs[`${sindex}-${vindex + 1}`][0].focus();
        });
      } else {
        // 聚焦到下一个
        nextInputVm.focus();
      }
    },
    // 添加规格名
    addSpName() {
      let nameKey = '';
      this.specifications.push({
        name: '',
        nameKey,
        values: [],
      });
    },
    // 移除规格名
    removeSpName(index) {
      this.specifications.splice(index, 1);
      this.$emit('fieldChanged');
    },
    // 移除规格值
    removeSpValue(sindex, index, v) {
      const _copy = [].concat(this.specifications[sindex].values);
      _copy.splice(index, 1);
      this.specifications[sindex].values = _copy;
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
      this.$emit('fieldChanged');
    },
    valueInput(v) {
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
      this.$emit('fieldChanged');
    },
    onChangeCheckbox() {
      window.__spcificationCheckbox_changed = true;
      this.$emit('fieldChanged');
    },
    onChangeSpCheckbox() {
      window.__spcificationSpCheckbox_changed = true;
      this.$emit('fieldChanged');
    },

    // 添加规格值
    addSpValue(index) {
      let voidValue = {
        value: '',
        checked: true,
        valueKey: this.$utils.genkey.get('v'),
        note: '',
      };
      if (index === 0) voidValue.imageUrl = '';
      this.specifications[index].values.push(voidValue);
      window.__spcificationImg_changed = voidValue.valueKey; // 用于skuList生成时的图片取值规则
    },

    imageUploadSuccess(url, v, sindex, vi) {
      v.imageUrl = url;
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      this.$emit('fieldChanged');
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    imageUploadDel(v, sindex, vi) {
      v.imageUrl = '';
      this.$emit('change', JSON.parse(JSON.stringify(this.specifications)));
      this.$emit('fieldChanged');
      window.__spcificationImg_changed = v.valueKey; // 用于skuList生成时的图片取值规则
    },
    async validate(specifications) {
      const specificationValid = await this.validateSpecForm();
      if (!specificationValid) {
        return false;
      }
      return true;
    },
    validateSpecForm() {
      const valueForms = this.$refs.specFormRef;
      const skuForms = this.$refs.skuForm || [];
      return new Promise(resolve => {
        if (!valueForms || valueForms.length === 0) {
          resolve(true);
          return false;
        }
        const promiseList = valueForms.concat(Array.isArray(skuForms) ? skuForms : [skuForms]).map(item => {
          return new Promise(resolve => {
            item.validate(valid => {
              resolve(valid);
            });
          });
        });
        Promise.all(promiseList)
          .then(results => {
            const allValid = results.every(result => result);
            if (!allValid) {
              resolve(allValid);
            }
            resolve(true);
          })
          .catch(() => {
            console.log('validateSpecForm has Error');
            resolve(false);
          });
      });
    },
    genFormItemValueRule(specItem, v, vi) {
      let valueValidator = (rule, value, callback) => {
        if (value) {
          const findItem = specItem.values.find((item, i) => item.value === value && i !== vi);
          if (findItem) {
            return callback(new Error('请勿输入相同规格值'));
          }
        }
        callback();
      };
      return [{ required: true, message: '规格值必填' }, { validator: valueValidator }];
    },
    genFormItemRemarkRule(v) {
      let valueValidator = (rule, value, callback) => {
        // const totallen = ((v.value || '') + (v.note || '')).length;
        // if (totallen > 22) {
        //   return callback(new Error('规格值+备注不超过22个字'));
        // }
        callback();
      };
      return [{ validator: valueValidator }];
    },
    genFormItemImgRule(valueItem, specItem, ref) {
      let valueValidator = async (rule, value, callback) => {
        const refImg = this.$refs[ref];
        if (valueItem.imageUrl && refImg && refImg[0]) {
          let errMsg = await refImg[0].method_validImage();
          if (errMsg) {
            return callback(new Error(errMsg));
          } else {
            callback();
          }
        }
        callback();
      };
      return [
        {
          required: true,
          validator: valueValidator,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.block-wrap {
  border: 1px solid #dcdfe6;
}
.title-bg {
  display: flex;
  align-items: center; // 垂直居中
  justify-content: space-between; // 两端对齐
  background: #f8f8f8;
  padding: 7px 10px;
  position: relative; // 为绝对定位提供参考
  .delete-btn {
    margin-left: auto; // 自动左外边距将按钮推到最右侧
  }
}

.specification-value {
  display: flex;
  padding: 7px 10px;
  &-flex {
    display: inline-flex;
    flex-wrap: wrap;
    width: 90%;
    &_item {
      margin-right: 10px;
      margin-bottom: 10px;
    }
    &_img {
      width: 82px;
      height: 82px;
      margin-top: 10px;
      position: relative;
    }
    .el-input {
      width: 160px;
    }
    .specification-value-flex_item {
      .el-form-item__error {
        margin-left: 0 !important;
      }
    }
  }
}
.del-input-wrap {
  position: relative;
  padding-right: 10px;
  &:hover {
    .del-btn {
      display: flex;
    }
  }
  .del-btn {
    cursor: pointer;
    display: none;
    position: absolute;
    color: #fff;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.3);
    justify-content: center;
    align-items: center;
    width: 18px;
    height: 18px;
    top: 0;
    right: 0;
    border-radius: 50%;
    transform: translate(45%, -45%);
  }
  .input-remark {
    margin-left: 10px;
  }
}
.remarkWrap {
  margin-top: 5px;
}
.block-specification {
  max-height: 444px;
  overflow-y: auto;
}
.my-dynamic-class {
  display: block;
}
.specification-value-flex_img {
  width: 100%;
}
</style>